import {put,takeLatest,call} from 'redux-saga/effects';
import * as extraService from "../../../../services/extraService.js";
import {
    GET_EXTRAS,
    GET_EXTRAS_SUCCESS,
    GET_EXTRAS_ERROR
}
    from "../../../actions/menu/extras";

function* getExtrasSaga(action) {
    try {
        const data=yield call(extraService.GetExtras,action.payload)
        yield put({
            type: GET_EXTRAS_SUCCESS,
            payload: data
        });

    } catch(error) {
        yield put({
            type: GET_EXTRAS_ERROR,error: error.data
        });
    }
}


export function* getExtrasSagaWatcher() {
    yield takeLatest(GET_EXTRAS,getExtrasSaga);
}